module.exports = __webpack_public_path__ + "img/Recycled_Material.f329ddd8.png";